import { InjectionToken } from '@angular/core';

export interface IAppConfig {
    URL: string;
    VnWebURL: string;
    GMapGeoURL: string;
  }

  // Configuration values for our app
  export const AppConfig: IAppConfig = {
    //  URL: '//portal.dksh.com/epclientws/api/', //Production
    // URL: '//localhost:51884/api/',
   URL: '//app-sg-cc-easyorderdevws01d.azurewebsites.net/api/', // Development API URL
    // URL: '//app-sg-cc-easyorderstgws01q.azurewebsites.net/api/', // Staging API URL    

     //VnWebURL:'easyorderdev.vnbizbox.com',  //VN development Web URL
     VnWebURL:'easyorderstg.vnbizbox.com',  //VN stage Web URL

    GMapGeoURL: 'https://maps.googleapis.com/maps/api/geocode/json'
  };
  
  // Create a config token to avoid naming conflicts
  export const APP_CONFIG = new InjectionToken<IAppConfig>('config');



// WEBPACK FOOTER //
// ./src/config/app-config.ts